import {Notification} from 'element-ui'
import {merge} from 'lodash'
import bus from '@utils/bus'

/**
 * Função que trata as options informadas
 * @param options
 * @returns Object
 */
function _handleData (options) {
  const defaultOptions = {
    title: 'Sucesso!',
    message: 'Os dados foram gravados',
    offset: 50,
    duration: 3000
  }
  options = merge(defaultOptions, options)
  if (options.hasOwnProperty('hideLoader') && options.hideLoader) {
    bus.$emit('hide-loader')
  }
  return options
}

/**
 * Mostra notificação de sucesso
 * @param options
 */
function _success (options) {
  options = _handleData(options)
  Notification.success(options)
}

/**
 * Mostra notificação de aviso
 * @param options
 */
function _warning (options) {
  options = _handleData(options)
  Notification.warning(options)
}

export const success = _success
export const warning = _warning
